import { render, staticRenderFns } from "./CalculatorOrderAddonPane.vue?vue&type=template&id=f8175f3c&scoped=true&"
import script from "./CalculatorOrderAddonPane.vue?vue&type=script&lang=js&"
export * from "./CalculatorOrderAddonPane.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorOrderAddonPane.vue?vue&type=style&index=0&id=f8175f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8175f3c",
  null
  
)

export default component.exports